import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const LOGO = "/logo.png";

export const fileUrl = (u) => {
  if (!u) return "";
  return u.startsWith("/api") ? `${BACKEND}${u}` : u;
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export const WA_APP_KEY = "safarshala_wa_app";
export const getWaApp = () => localStorage.getItem(WA_APP_KEY) || "whatsapp";
export const setWaApp = (v) => { localStorage.setItem(WA_APP_KEY, v); window.dispatchEvent(new Event("wa-app-changed")); };
const isAndroid = () => /android/i.test(navigator.userAgent);

export function buildWaLink(number, message) {
  let clean = (number || "").replace(/[^0-9]/g, "").replace(/^0+/, "");
  if (clean.length === 10) clean = "91" + clean;
  if (clean.length === 12 && clean.startsWith("0")) clean = clean.slice(1);
  const text = encodeURIComponent(message || "");
  const web = `https://wa.me/${clean}?text=${text}`;
  if (getWaApp() === "business" && isAndroid()) {
    return `intent://send?phone=${clean}&text=${text}#Intent;scheme=whatsapp;package=com.whatsapp.w4b;S.browser_fallback_url=${encodeURIComponent(web)};end`;
  }
  return web;
}

// intent:// links must navigate the current tab on Android; window.open is blocked for them
export function openWa(url, delayMs = 0) {
  const go = () => { if (url.startsWith("intent://")) window.location.assign(url); else window.open(url, "_blank", "noopener"); };
  delayMs ? setTimeout(go, delayMs) : go();
}

export const safeUrl = (u) => (typeof u === "string" && /^https?:\/\//i.test(u.trim()) ? u.trim() : null);
